"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tk = tk;
exports.getBundle = getBundle;
// ADR-0007 Class A：禁 ESM-only 的 `import ... with { type: 'json' }`；依赖 tsconfig resolveJsonModule。
const zh_CN_json_1 = __importDefault(require("../locales/zh-CN.json"));
const km_KH_json_1 = __importDefault(require("../locales/km-KH.json"));
const en_json_1 = __importDefault(require("../locales/en.json"));
const types_js_1 = require("./types.js");
const BUNDLE = {
    'zh-CN': zh_CN_json_1.default,
    'km-KH': km_KH_json_1.default,
    en: en_json_1.default,
};
function resolvePath(tree, path) {
    const segments = path.split('.');
    let cursor = tree;
    for (const seg of segments) {
        if (cursor === undefined || cursor === null)
            return undefined;
        if (typeof cursor === 'string')
            return undefined;
        cursor = cursor[seg];
    }
    return typeof cursor === 'string' ? cursor : undefined;
}
function interpolate(str, params) {
    if (!params)
        return str;
    return str.replace(/\{(\w+)\}/g, (_, name) => params[name] === undefined ? `{${name}}` : String(params[name]));
}
function tk(key, options = {}) {
    const { locale = types_js_1.DEFAULT_LOCALE, fallback, params } = options;
    const primary = resolvePath(BUNDLE[locale], key);
    if (primary !== undefined)
        return interpolate(primary, params);
    if (locale !== types_js_1.DEFAULT_LOCALE) {
        const defaultValue = resolvePath(BUNDLE[types_js_1.DEFAULT_LOCALE], key);
        if (defaultValue !== undefined)
            return interpolate(defaultValue, params);
    }
    return fallback ?? key;
}
function getBundle(locale) {
    return BUNDLE[locale];
}
//# sourceMappingURL=tk.js.map